import { Dialog } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./SupplierDashboard.scss";
import { dateParserWithoutTimeAndDate } from "../../../helper";

const SupplierAllocationsDialog = (props: any) => {
  const { open, onClose, allocationsList } = props;
  const handleFieldValue = (value: any) => {
    if (value === "" || value === null) return "N.A";
    return value;
  };

  return (
    <Dialog open={open} className="pw-supplier-allocations-dialog">
      <div className="w-full h-full flex flex-col justify-start items-start divide-y-[2px]">
        <div className="w-full flex flex-row justify-between items-center p-4">
          <div>Allocation methods</div>
          <div onClick={() => onClose()}>
            <CloseIcon />
          </div>
        </div>
        {allocationsList.length
          ? allocationsList.map((eachAllocation: any) => (
              <div className="w-full">
                <div className="w-full flex flex-col p-4 pr-8 bo">
                  <div className="w-full flex flex-row justify-between items-center text-sm">
                    <div>
                      {dateParserWithoutTimeAndDate(eachAllocation.from_date)}
                      {" - "}
                      {dateParserWithoutTimeAndDate(eachAllocation.to_date)}
                    </div>
                    <div>
                      {eachAllocation.allocated_total_emissions || 0}
                      <span className="text-xs">(tCO2e)</span>
                    </div>
                  </div>
                  <div
                    className="w-full flex flex-row justify-start items-center text-xs mt-2 mb-1 pl-4"
                    onClick={() => {
                      console.log(allocationsList);
                    }}
                  >
                    <span className="pw-neutral-600-color">
                      Allocation method:
                    </span>
                    &nbsp;
                    <span>{eachAllocation.name}</span>
                  </div>
                  {eachAllocation.name === "Allocate by fixed percentage" ? (
                    <div className="w-full flex flex-row justify-start items-center text-xs my-1 pl-4">
                      <span className="pw-neutral-600-color">
                        Allocation percentage:{" "}
                      </span>
                      &nbsp;
                      {handleFieldValue(eachAllocation.allocated_percentage)}
                    </div>
                  ) : (
                    ""
                  )}
                  {eachAllocation.name === "Production volume approach" ? (
                    <div className="w-full flex flex-row justify-start items-center text-xs my-1 pl-4">
                      <span className="pw-neutral-600-color">
                        Allocation percentage:{" "}
                      </span>
                      &nbsp;
                      {eachAllocation.total_production &&
                      eachAllocation.supplied_count &&
                      !isNaN(eachAllocation.total_production) &&
                      !isNaN(eachAllocation.supplied_count)
                        ? (parseFloat(eachAllocation.supplied_count) * 100) /
                          parseFloat(eachAllocation.total_production)
                        : "-"}
                    </div>
                  ) : (
                    ""
                  )}
                  {eachAllocation.name === "Economic" ? (
                    <div className="w-full flex flex-row justify-start items-center text-xs my-1 pl-4">
                      <span className="pw-neutral-600-color">
                        Allocation percentage:{" "}
                      </span>
                      &nbsp;
                      {eachAllocation.total_revenue &&
                      eachAllocation.sales &&
                      !isNaN(eachAllocation.total_revenue) &&
                      !isNaN(eachAllocation.sales)
                        ? (parseFloat(eachAllocation.sales) * 100) /
                          parseFloat(eachAllocation.total_revenue)
                        : "-"}
                    </div>
                  ) : (
                    ""
                  )}
                  {eachAllocation.name === "Product carbon footprint" ? (
                    eachAllocation.transactions?.length ? (
                      eachAllocation.transactions
                        .filter(
                          (eachTransaction: any) =>
                            eachTransaction.emission_factor
                        )
                        .map((eachTransaction: any) => (
                          <div className="w-full flex flex-row justify-between items-center text-xs my-1 pl-4">
                            <div>
                              <span className="pw-neutral-600-color">
                                Product:{" "}
                              </span>
                              {handleFieldValue(eachTransaction.field_name)}
                            </div>
                            <div>
                              <span className="pw-neutral-600-color">
                                Total number of units:{" "}
                              </span>
                              {handleFieldValue(eachTransaction.total_units)}
                            </div>
                            <div>
                              <span className="pw-neutral-600-color">
                                Emission per unit(tCO2e):{" "}
                              </span>
                              {handleFieldValue(
                                eachTransaction.emission_factor
                              )}
                            </div>
                            <div>
                              <span className="pw-neutral-600-color">
                                Emission(tCO2e):{" "}
                              </span>
                              {handleFieldValue(eachTransaction.value)}
                            </div>
                          </div>
                        ))
                    ) : (
                      ""
                    )
                  ) : (
                    <div className="w-full flex flex-row justify-between items-center text-xs my-1 pl-4">
                      <div>
                        <span className="pw-neutral-600-color">
                          Scope 1(tCO2e):{" "}
                        </span>
                        {handleFieldValue(eachAllocation.allocated_scope1)}
                      </div>
                      <div>
                        <span className="pw-neutral-600-color">
                          Scope 2(tCO2e):{" "}
                        </span>
                        {handleFieldValue(eachAllocation.allocated_scope2)}
                      </div>
                      <div>
                        <span className="pw-neutral-600-color">
                          Scope 3(tCO2e):{" "}
                        </span>
                        {handleFieldValue(eachAllocation.allocated_scope3)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))
          : ""}
      </div>
      {/* {allocationsList?.length} */}
    </Dialog>
  );
};

export default SupplierAllocationsDialog;
